// @ vendors

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// @ components
import withFiltersFeatures from './withFiltersFeatures'


class FiltersContainer extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.renderFilters(this)}
            </div>
        )
    }
}

FiltersContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    filtersId: PropTypes.string.isRequired,
    renderFilters: PropTypes.func.isRequired,
};

export default withFiltersFeatures(FiltersContainer);